function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { TOOLTIP_Y_OFFSET as e, TRIANGLE_OFFSETS as t, DEFAULT_OFFSET as m, UP_ARROW as O, TOOLTIP_X_OFFSET as w, LEFT_ARROW as p, RIGHT_ARROW as R, TRIANGLE_BORDER as T } from "./index.es15.js";
import { PositionVariants as r } from "./index.es172.js";

var F = function F(c, h) {
  var _r$aboveRight$r$above;

  var f = c.width,
      g = c.height,
      o = c.left,
      d = c.right,
      n = c.top,
      a = c.bottom,
      _document$documentEle = document.documentElement,
      l = _document$documentEle.clientHeight,
      i = _document$documentEle.clientWidth,
      s = f / 2 - t.x - T;
  return (_r$aboveRight$r$above = {}, _defineProperty(_r$aboveRight$r$above, r.aboveRight, {
    bottom: l - n + e,
    left: o + s + window.scrollX,
    triangleOffset: {
      bottom: t.y,
      left: t.x,
      transform: m.triangleOffset.transform
    }
  }), _defineProperty(_r$aboveRight$r$above, r.aboveCenter, {
    bottom: l - n + e,
    left: o + f / 2 + window.scrollX,
    transform: "translate(-50%, 0)",
    triangleOffset: {
      bottom: t.y,
      transform: m.triangleOffset.transform
    }
  }), _defineProperty(_r$aboveRight$r$above, r.aboveLeft, {
    bottom: l - n + e,
    right: i - d + s - window.scrollX,
    triangleOffset: {
      bottom: t.y,
      right: t.x,
      transform: m.triangleOffset.transform
    }
  }), _defineProperty(_r$aboveRight$r$above, r.underRight, {
    top: a + e,
    left: o + s + window.scrollX,
    triangleOffset: {
      top: t.y,
      left: t.x,
      transform: "rotate(".concat(O, ")")
    }
  }), _defineProperty(_r$aboveRight$r$above, r.underCenter, {
    top: a + e,
    left: o + f / 2 + window.scrollX,
    transform: "translate(-50%)",
    triangleOffset: {
      top: t.y,
      transform: "rotate(".concat(O, ")")
    }
  }), _defineProperty(_r$aboveRight$r$above, r.underLeft, {
    top: a + e,
    right: i - d + s - window.scrollX,
    triangleOffset: {
      top: t.y,
      right: t.x,
      transform: "rotate(".concat(O, ")")
    }
  }), _defineProperty(_r$aboveRight$r$above, r.left, {
    top: n + g / 2,
    right: i - o + w - window.scrollX,
    transform: "translate(0, -50%)",
    triangleOffset: {
      right: t.y,
      transform: "rotate(".concat(p, ")")
    }
  }), _defineProperty(_r$aboveRight$r$above, r.right, {
    top: n + g / 2,
    left: o + f + w + window.scrollX,
    transform: "translate(0, -50%)",
    triangleOffset: {
      left: t.y,
      transform: "rotate(".concat(R, ")")
    }
  }), _r$aboveRight$r$above)[h];
};

export { F as defineOffset };